// Pure helpers for ConsolidatedInvoiceEditDialog, kept dependency-free so
// they can be unit tested without the component's Redux/i18n wiring.

// The rate dropdown's option values. The backend accepts exactly these
// (chain/serializers.py ALLOWED_VAT_RATES) and rejects anything else with a
// 400, so a row must never leave the editor carrying another value.
export var VAT_OPTIONS = ['0', '10', '14', '24', '25.5'];

// '1 234,50' / '1234.50' -> 1234.5, garbage -> null
export function parseDecimal(value) {
  if (value === null || value === undefined || value === '') return null;
  var normalized = String(value).replace(/\s/g, '').replace(',', '.');
  if (!/^-?\d+(\.\d+)?$/.test(normalized)) return null;
  return parseFloat(normalized);
}

export function isKnownVatOption(value) {
  return VAT_OPTIONS.indexOf(value) !== -1;
}

// A stored rate in the exact form of its dropdown option. The API serialises
// the numeric(5,2) column as '25.50' / '24.00'; a controlled <select> matches
// options by string, and for an unmatched value the browser shows the FIRST
// option — which is how every row of an edited invoice read "0 %" in
// production while the footer still summed VAT from the real rates.
// Unparseable input yields '' so the row renders an explicit placeholder
// option and fails validation instead of silently claiming 0 %.
export function toVatOption(value) {
  var parsed = parseDecimal(value);
  return parsed === null ? '' : String(parsed);
}
